import { useDispatch, useSelector } from 'react-redux';
import { Popover } from '@mui/material';
import { useState } from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import { ArrowDropDown } from '@mui/icons-material';

import logo from '@/assets/bd-logo.png';
import icAdd from '@/assets/icons/add-document.png';
import icHome from '@/assets/icons/home.png';
import icUser from '@/assets/icons/user.png';
import icEdit from '@/assets/icons/edit-document-h.png';
import icCopy from '@/assets/icons/duplicate-document-h.png';
import icDelete from '@/assets/icons/delete-document-h.png';
// import icShare from '@/assets/icons/share-document-h.png';
import { route } from '@/constants/routeName';
import { menuItems } from './menuItems';

import auth from '@/api/auth';
import { twMerge } from 'tailwind-merge';

const mItem = (icon, label) => {
	return (
		<span className='relative'>
			<img src={icon} className='absolute top-2 w-[10px] -left-4' />
			{label}
		</span>
	);
};

const { signOut } = auth();
const ImgLogo = () => <img src={logo} className='w-32 h-auto lg:w-48 xl:w-52' alt='bds logo' />;
export default function Header() {
	const dispatch = useDispatch();
	const location = useLocation();
	const params = useParams();
	const { pathname } = location;

	const user = useSelector((state) => state.auth.user);
	const refresh = useSelector((state) => state.auth.refresh);
	const key = useSelector((state) => state.auth.key);

	const [anchorEl, setAnchorEl] = useState(null);

	const isAllowed = [1, 2, 3, 4, 9].includes(user?.privilegelevelid);
	const isDetail = pathname.includes(route.project) && params.project;
	const isPublic = pathname.includes(route.file) && !!params.id && !!params.name && !!params.number;

	const onSignOut = () => {
		if (!key && !refresh) return;
		signOut({ refresh: refresh })
			.then((res) => {
				if (res.status === 205) {
					dispatch({ type: 'auth/setLogout' });
				}
			})
			.catch((e) => {
				if (e.status === 401) {
					dispatch({ type: 'auth/setLogout' });
				}
			});
	};

	const onDelete = () => {
		dispatch({ type: 'project/setActionsProject', payload: { key: 'projectDelete', value: true } });
	};
	const onCopy = () => {
		dispatch({ type: 'project/setActionsProject', payload: { key: 'projectCopy', value: true } });
	};
	// const onShare = () => {
	// 	dispatch({ type: 'project/setActionsProject', payload: { key: 'projectShare', value: true } });
	// };
	const homeClick = () => {
		if (isPublic) return;
		if (pathname === '/') {
			dispatch({ type: 'trigger/triggerAPI', payload: { key: 'homeReset', value: true } });
		}
	};

	return (
		<div className='flex w-full shadow-lg bg-primary'>
			<div className='container flex items-center px-4 py-4 mx-auto sm:px-0'>
				{isPublic ? (
					<ImgLogo />
				) : (
					<Link to={`/`} onClick={homeClick}>
						<ImgLogo />
					</Link>
				)}
				<div className='flex gap-1 ml-auto sm:gap-4'>
					<div className={twMerge('flex items-center gap-2', !isPublic ? 'pr-4 border-r-2 border-white' : 'md:pr-4')}>
						{!isPublic && (
							<>
								{isAllowed && (
									<Link to={`${route.project}/add`}>
										<img src={icAdd} />
									</Link>
								)}
								<Link to={`/`} onClick={homeClick}>
									<img src={icHome} />
								</Link>
							</>
						)}
					</div>
					{isDetail && isAllowed && (
						<div className='flex items-center gap-2 pr-4 border-r-2 border-white'>
							<Link to={`${route.project}/edit/${params.id}`}>
								<img src={icEdit} />
							</Link>
							{/* <Link to={`${route.project}/duplicate/${params.id}`}>
								<img src={icCopy} />
							</Link> */}
							<button onClick={onCopy} className='header-ic'>
								<img src={icCopy} />
							</button>
							<button onClick={onDelete} className='header-ic'>
								<img src={icDelete} />
							</button>
							{/* <button onClick={onShare} disabled className='cursor-not-allowed'>
								<img src={icShare} />
							</button> */}
						</div>
					)}
					{!isPublic && (
						<div className='flex items-center text-xs text-white sm:text-base'>
							<div className='relative h-10 ic-profile sm:h-14'>
								<img src={icUser} className='object-contain w-full h-full' />
							</div>
							<button onClick={(e) => setAnchorEl(e.currentTarget)} className='flex flex-row items-center gap-1 bg-transparent'>
								<div className='flex flex-col gap-1'>
									<span>Hi, {user?.email?.substring(0, user.email.indexOf('@'))}</span>
									<span>{user.privilegelevelname || '-'}</span>
								</div>
								<ArrowDropDown className='' />
							</button>
						</div>
					)}
				</div>
			</div>
			<Popover
				open={!!anchorEl}
				anchorEl={anchorEl}
				onClose={() => setAnchorEl(null)}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'right',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'right',
				}}
			>
				<div className='flex flex-col py-1'>
					{menuItems
						.filter((m) => !m.privileges || m.privileges.includes(user?.privilegelevelid))
						.map((m) => {
							return m.url ? (
								<Link
									to={m.url}
									key={m.name}
									className={twMerge(
										'relative flex items-center pl-7 pr-6 py-1 hover:bg-[#f8f9fa]',
										`/${m.url}` === pathname ? 'bg-[#f8f9fa]' : ''
									)}
									onClick={() => setAnchorEl(null)}
								>
									{mItem(m.icon, m.label)}
								</Link>
							) : (
								<button key={m.name} className='relative flex items-center pl-7 pr-6 py-1 hover:bg-[#f8f9fa]' onClick={onSignOut}>
									{mItem(m.icon, m.label)}
								</button>
							);
						})}
				</div>
			</Popover>
		</div>
	);
}
